import { FC } from 'react';
import { FileIcon, defaultStyles } from 'react-file-icon';
import { UploadFileApi } from 'types/upload-type';

interface IconUploadFileProps {
  file: UploadFileApi;
}

const IconUploadFile: FC<IconUploadFileProps> = ({ file }) => {
  const extension = file.response?.extension ?? file.name.split('.').reverse()[0];

  const customStyles = extension in defaultStyles ? defaultStyles[extension as keyof typeof defaultStyles] : {};

  return (
    <span className="react-file-icon-wrapper">
      <FileIcon extension={extension.toUpperCase()} {...customStyles} />
    </span>
  );
};

export default IconUploadFile;
